import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AlertBanner, usePageTitle, useTheme } from '@flowcore-water/ui';

export const LoginPage: React.FC = () => {
  usePageTitle('Training', 'Login');
  const { t } = useTheme();
  const { signInWithGoogle, isDemoMode } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSignIn = async () => {
    setLoading(true);
    setError(null);
    try {
      await signInWithGoogle();
      navigate('/tree');
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Sign in failed';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center" style={{ background: '#080c14' }}>
      <div className="w-full max-w-md rounded-xl border /60 p-8 shadow-2xl" style={{ background: '#0d1321' }}>
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <div className="h-16 w-16 rounded-lg bg-cyan-600 flex items-center justify-center shadow-lg shadow-cyan-600/20">
            <span className=" font-black text-3xl" style={{ color: t.textPrimary }}>F</span>
          </div>
        </div>

        {/* Title */}
        <h1 className="mb-2 text-center text-3xl font-black tracking-widest uppercase " style={{ color: t.textPrimary }}>
          Flowcore
        </h1>
        <p className="mb-8 text-center text-sm font-mono uppercase tracking-wider " style={{ color: t.accent }}>
          Training Tracker
        </p>

        {/* Demo Mode Badge */}
        {isDemoMode && (
          <div className="mb-6 rounded-lg border border-amber-500/40 p-3" style={{ background: '#1a1708' }}>
            <p className="text-sm text-amber-400">
              <span className="font-semibold">Demo Mode:</span> Using local storage instead of Firebase
            </p>
          </div>
        )}

        {/* Error */}
        {error && <AlertBanner variant="error" message={error} />}

        {/* Sign In Button */}
        <button
          onClick={handleSignIn}
          disabled={loading}
          className="w-full rounded-lg bg-cyan-600 px-6 py-3 font-bold  hover:bg-cyan-500 transition-colors disabled:bg-slate-700 disabled: disabled:cursor-not-allowed flex items-center justify-center gap-2 uppercase tracking-wide" style={{ color: t.textPrimary }}
        >
          {loading ? 'Signing in...' : isDemoMode ? 'Enter Demo Mode' : 'Sign in with Google'}
        </button>

        {/* Demo Info — only shown in demo mode */}
        {isDemoMode && (
          <div className="mt-8 rounded-lg border /60 p-4" style={{ background: '#0a0f1a' }}>
            <h3 className="mb-2 font-semibold  text-sm uppercase tracking-wide" style={{ color: t.textSecondary }}>Demo Credentials</h3>
            <p className="text-sm " style={{ color: t.textMuted }}>
              <span className=" font-mono" style={{ color: t.accent }}>robert@flowcorewater.com</span>
            </p>
            <p className="text-xs  mt-1" style={{ color: t.textMuted }}>
              Use this email to access the demo with admin privileges
            </p>
          </div>
        )}

        {/* Footer */}
        <p className="mt-8 text-center text-xs text-slate-600">
          Only @flowcorewater.com accounts are authorized
        </p>
      </div>
    </div>
  );
};
